import { Avatar, Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react'
import { StandardTableActions } from '../../../Components/StandardTableActions/StandardTableActions';
import { DataTable } from '../../../Components/Table/DataTable';
import { IDataTableProps, MobileLogoRenderType, RenderType } from '../../../Components/Table/interfaces/IDataTableProps';
import { useAppSelector, IStoreState, useAppDispatch } from '../../../redux';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import { CustomButton } from '../../../Components/CustomButton';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { MARKETING_CAMPAIGNS_ROUTE } from '../Marketing.constants';
import { ICoupon, clearCouponsStateSync, fetchAllCouponsListAsync } from '../../../redux/marketing/coupon-codes';
import { clearCampaignStateSync, fetchAllCampaignsListAsync, ICampaign } from '../../../redux/marketing/campaigns';
import { useOutletContext } from '../../../providers';

export const CampaignsTable = () => {
     const { outlet_details: { outlet_uuid } } = useOutletContext();
    const {
        data: campaignsData,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.marketing.campaigns.campaign_list);
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const [pagination, setPagination] = React.useState({
        pageNumber: 1,
        rowsPerPage: 10,
    });


    const dataTableProps: IDataTableProps = {
        isPagination: true,
        rowsPerPageOptions: 25,
        isDataLoading: false,
        mobileLogo: {
            type: MobileLogoRenderType.reactNode,
            onMobileLogoRender: (data: any) => {
                return (
                    <Avatar
                        sx={{
                            width: 45,
                            height: 45,
                            color: "#fff",
                            ml: "-8px",
                            mr: 2,
                        }}
                    ></Avatar>
                );
            },
        },

        columns: [
            {
                key: "view",
                headerName: "Actions",
                fieldName: "",
                headingAlign: "center",
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (value, row: ICampaign) => {
                    return (
                        <StandardTableActions
                            onEditClick={() => navigate(`${MARKETING_CAMPAIGNS_ROUTE}/manage/${row.campaign_uuid}`)}
                        />
                    );
                },
            },
            {
                key: "campaign_type",
                headerName: "Campaign Type",
                fieldName: "campaign_type",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "campaign_repeat",
                headerName: "Campaign Repeat",
                fieldName: "campaign_repeat",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "campaign_start_date",
                headerName: "Campaign Start Date",
                fieldName: "campaign_start_date",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },

            {
                key: "campaign_end_date",
                headerName: "Campaign End Date",
                fieldName: "campaign_end_date",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
        ],

        items: campaignsData,
        onPageChange: (newPageNumber: number) => {
            setPagination({ ...pagination, pageNumber: newPageNumber });
        },
        onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
            setPagination({
                pageNumber: pageNumber,
                rowsPerPage: rowsPerPage,
            });
        },
    };


    React.useEffect(() => {
        if (outlet_uuid)
            dispatch(
                fetchAllCampaignsListAsync({
                    outlet_uuid,
                    page: pagination.pageNumber,
                    rowsPerPage: pagination.rowsPerPage,
                }),
            );
    }, [pagination, outlet_uuid]);

    React.useEffect(() => {
        return () => {
            dispatch(clearCampaignStateSync());
        };
    }, []);

    const isLightMode = useTheme().palette.mode === "light";

    return (
        <PageContainer title="Campaigns" description='inner page' >
            <Stack direction="row" justifyContent="space-between" alignItems="center" my={2} >
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                    <Typography variant='h2'>Campaigns</Typography>
                </Stack>
                <CustomButton
                    variant="outlined"
                    color="primary"
                    sx={{
                        display: "flex",
                        marginLeft: "auto",
                        marginY: 2,
                        minWidth: "80px !important",
                        backgroundColor: isLightMode
                          ? "var(--secondary-color)"
                          : "var(--primary-color)",
                        color: isLightMode
                          ? "var(--text-light-color)"
                          : "var(--text-dark-color)",
                        border: isLightMode
                          ? "var(--border-light-color) 1px solid"
                          : "var(--border-dark-color) 1px solid",
                        "&:hover": {
                          backgroundColor: isLightMode
                            ? "var(--secondary-color)"
                            : "var(--tertiary-color)",
                          opacity: isLightMode ? 0.85 : 1,
                          // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                          border: isLightMode
                            ? "var(--border-light-color) 1px solid"
                            : "var(--border-dark-color) 1px solid",
                        },
                      }}
                    onClick={() => navigate(`${MARKETING_CAMPAIGNS_ROUTE}/manage`)}
                >
                    Run New Campaign
                </CustomButton>
            </Stack>
            <DataTable {...dataTableProps} />
        </PageContainer>
    );
}
